import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export function LocationSection() {
  const infoItems = [{
    icon: <MapPinIcon className="w-6 h-6 text-delux-gold" data-id="element-189" />,
    text: '1145 Homestead Rd N, Lehigh Acres, FL 33936'
  }, {
    icon: <PhoneIcon className="w-6 h-6 text-delux-gold" data-id="element-190" />,
    text: 'Llama o escribe: (786) 651-6944',
    link: 'tel:7866516944'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-delux-gold" data-id="element-191" />,
    text: 'Abiertos hasta las 7 PM — porque tu tiempo también importa'
  }, {
    icon: <CheckCircleIcon className="w-6 h-6 text-delux-gold" data-id="element-192" />,
    text: 'Se aceptan sin cita previa, se recomienda reservar'
  }];
  return <section id="ubicacion" className="bg-delux-alt py-20 px-4 sm:px-6 lg:px-8 border-y border-delux-gold/10" data-id="element-193">
      <style data-id="element-194">{`
        @keyframes holographic {
          0% {
            border-color: rgba(200, 164, 90, 0.6);
            box-shadow: 0 0 15px rgba(200, 164, 90, 0.3), inset 0 0 15px rgba(200, 164, 90, 0.05);
          }
          25% {
            border-color: rgba(212, 175, 55, 0.8);
            box-shadow: 0 0 25px rgba(212, 175, 55, 0.4), inset 0 0 20px rgba(212, 175, 55, 0.08);
          }
          50% {
            border-color: rgba(160, 200, 180, 0.6);
            box-shadow: 0 0 20px rgba(160, 200, 180, 0.3), inset 0 0 15px rgba(160, 200, 180, 0.05);
          }
          75% {
            border-color: rgba(180, 160, 220, 0.7);
            box-shadow: 0 0 25px rgba(180, 160, 220, 0.35), inset 0 0 20px rgba(180, 160, 220, 0.06);
          }
          100% {
            border-color: rgba(200, 164, 90, 0.6);
            box-shadow: 0 0 15px rgba(200, 164, 90, 0.3), inset 0 0 15px rgba(200, 164, 90, 0.05);
          }
        }
        .holographic-border {
          animation: holographic 4s ease-in-out infinite;
          border-width: 2px;
          border-style: solid;
        }
        @keyframes scanline {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(100%); }
        }
      `}</style>

      <div className="max-w-5xl mx-auto text-center" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <div className="w-16 h-16 rounded-full bg-delux-gold/10 flex items-center justify-center mx-auto mb-6" data-id="element-197">
            <MapPinIcon className="w-8 h-8 text-delux-gold" data-id="element-198" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-199">
            Ubicados Donde Tú Vives
          </h2>
          <p className="font-body text-xl text-delux-body mb-12" data-id="element-200">
            Estamos justo aquí en Sunshine Plaza — porque tu transformación no
            debería requerir un viaje largo.
          </p>
        </motion.div>

        {/* Embedded Map with Holographic Effect */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="mb-12 relative" data-id="element-201">
          <div className="holographic-border rounded-xl overflow-hidden relative" data-id="element-202">
            {/* Scanline overlay for holographic feel */}
            <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden rounded-xl" data-id="element-203">
              <div className="absolute inset-x-0 h-24 bg-gradient-to-b from-delux-gold/8 via-delux-gold/3 to-transparent" style={{
              animation: 'scanline 3s linear infinite'
            }} data-id="element-204" />
            </div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-delux-gold rounded-tl-xl z-10" data-id="element-205" />
            <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-delux-gold rounded-tr-xl z-10" data-id="element-206" />
            <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-delux-gold rounded-bl-xl z-10" data-id="element-207" />
            <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-delux-gold rounded-br-xl z-10" data-id="element-208" />

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3567.8!2d-81.7095!3d26.6285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88db49e3c4a7c8f1%3A0x1234567890abcdef!2s1145%20Homestead%20Rd%20N%2C%20Lehigh%20Acres%2C%20FL%2033936!5e0!3m2!1sen!2sus!4v1710000000000" width="100%" height="350" style={{
            border: 0,
            filter: 'saturate(0.3) brightness(0.7) contrast(1.2)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Barbershop Delux Cut Location" className="w-full md:h-[400px] h-[300px]" data-id="element-209" />

            {/* Gold tint overlay */}
            <div className="absolute inset-0 bg-delux-gold/5 pointer-events-none rounded-xl" data-id="element-210" />
          </div>

          {/* Label below map */}
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="font-heading text-sm text-delux-gold/60 mt-4 tracking-widest uppercase" data-id="element-211">
            Sunshine Plaza — Lehigh Acres, FL
          </motion.p>
        </motion.div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-212">
          {infoItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-delux-card p-6 rounded-lg border border-delux-gold/20 flex items-start space-x-4" data-id="element-213">
              <div className="mt-1 flex-shrink-0" data-id="element-214">{item.icon}</div>
              {item.link ? <a href={item.link} className="font-body text-lg text-delux-white hover:text-delux-gold transition-colors" data-id="element-215">
                  {item.text}
                </a> : <p className="font-body text-lg text-delux-white" data-id="element-216">
                  {item.text}
                </p>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}